module.exports = __webpack_public_path__ + "img/google.4c9c3df6.svg";